import { render, staticRenderFns } from "./MkbTreeSelectDialog.vue?vue&type=template&id=61ce0c0a&scoped=true&"
import script from "./MkbTreeSelectDialog.vue?vue&type=script&lang=js&"
export * from "./MkbTreeSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./MkbTreeSelectDialog.vue?vue&type=style&index=0&id=61ce0c0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce0c0a",
  null
  
)

export default component.exports